/**
 * Xpert Verifications API
 * Calls for the Xpert Verified (async review) product.
 */
import api from './index';

export const verificationsApi = {
  /**
   * GET /api/verifications/categories
   * Returns the 9 V1 categories + 3 turnaround tiers with pricing.
   * Public — no auth required.
   */
  getCategories: async () => {
    const response = await api.get('/verifications/categories');
    return response.data;
  },

  /**
   * POST /api/verifications
   * Submit AI output for expert verification.
   * Requires auth (JWT). Returns the verification + checkout_url.
   */
  create: async (payload) => {
    const response = await api.post('/verifications', payload);
    return response.data;
  },

  /**
   * GET /api/verifications/me
   * List the current user's verifications.
   */
  listMine: async () => {
    const response = await api.get('/verifications/me');
    return response.data;
  },

  /**
   * GET /api/verifications/{id}
   */
  get: async (verificationId) => {
    const response = await api.get(`/verifications/${verificationId}`);
    return response.data;
  },

  /**
   * GET /api/verifications/{id}/brief — expert-side
   */
  getBrief: async (verificationId) => {
    const response = await api.get(`/verifications/${verificationId}/brief`);
    return response.data;
  },

  /**
   * POST /api/verifications/{id}/verdict — expert-side
   */
  submitVerdict: async (verificationId, payload) => {
    const response = await api.post(
      `/verifications/${verificationId}/verdict`,
      payload,
    );
    return response.data;
  },

  /**
   * GET /api/verifications/{id}/verdict — buyer-side verdict read.
   * BR-011 Tranche 3 — includes expert attachments + buyer rating.
   */
  getVerdict: async (verificationId) => {
    const response = await api.get(`/verifications/${verificationId}/verdict`);
    return response.data;
  },

  /**
   * POST /api/verifications/{id}/rating — buyer rates the verdict.
   * BR-011 Tranche 3.2 — 1-5 stars + optional text. Re-POSTing updates.
   */
  submitRating: async (verificationId, payload) => {
    const response = await api.post(
      `/verifications/${verificationId}/rating`,
      payload,
    );
    return response.data;
  },

  /**
   * GET /api/badges/{slug} — PUBLIC, no auth.
   */
  getPublicBadge: async (badgeSlug) => {
    const response = await api.get(`/badges/${badgeSlug}`);
    return response.data;
  },
};

export default verificationsApi;
